export function getTotalOnBoard(props) {
    const { remainTakeoff = 0, refuelingTakeoff = 0, expenseLandTakeoff = 0, excludeGround } = props || {};
    const totalOnBoard = +remainTakeoff + +refuelingTakeoff - (excludeGround ? +expenseLandTakeoff : 0);

    return totalOnBoard || 0;
}
